import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { describeOrderPayment, type OrderPaymentDescriptor } from "./describeOrderPayment";

/**
 * The "Bramka płatności" cell, shared by the global transactions list and the
 * per-product one so the two never drift.
 *
 * Two lines rather than one parenthesised string: the column is narrow and an
 * installment channel name pushed it into breaking mid-word.
 */
export const OrderPaymentCell = ({ order }: { order: OrderPaymentDescriptor }) => {
  const { t } = useTranslation("products");
  const { gateway, details } = describeOrderPayment(order, t);

  return (
    <div className="min-w-[120px]">
      <div>{gateway}</div>
      {details.length ? (
        <Typography.Text type="secondary" className="text-xs">
          {details.join(" · ")}
        </Typography.Text>
      ) : null}
    </div>
  );
};
